import { useMutation } from 'react-query'
import {
  GeneratePresignedUrlResponse,
  DeleteAttachmentsParams,
  DeleteAttachmentsResponse,
} from './types'
import { useCreateBetterIdRequest } from 'lib/services/config/betterId-config'
import { AxiosError } from 'axios'

export const useGeneratePresignedUrlMutation = () => {
  const { createBetterIdRequest } = useCreateBetterIdRequest()
  const url = 'operations/attachments/generate-put-presigned-url'
  return useMutation<GeneratePresignedUrlResponse, AxiosError, null>(
    async () => await createBetterIdRequest(url, { contentType: 'image/jpeg' })
  )
}

export const useDeleteAttachments = () => {
  const { createBetterIdRequest } = useCreateBetterIdRequest()
  const url = 'operations/attachments/delete-product-request-attachments'

  return useMutation<
    DeleteAttachmentsResponse,
    AxiosError,
    DeleteAttachmentsParams
  >(async (params) => await createBetterIdRequest(url, params))
}
